import React from 'react';
import { Link } from 'react-router-dom';

const QuickAction = ({ icon, iconBg, label, to }) => {
  return (
    <Link 
      to={to} 
      className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
    >
      <div className={`${iconBg} p-3 rounded-lg mb-2`}>
        <i className={`${icon} text-xl`}></i>
      </div>
      <span className="text-sm font-medium text-gray-700 text-center">{label}</span>
    </Link>
  );
};

export default QuickAction;